module.exports = __webpack_public_path__ + "static/img/48112.faabc94.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/products/48112.jpg
// module id = UD9t
// module chunks = 1